'use strict';

var App = App || {};

App.GalleryLightbox = function () {
  'use strict';

  var initialize = function initialize() {
    _initLightbox();
  };

  var _initLightbox = function _initLightbox() {
    $(".js-gallery-lightbox").fancybox({
      openEffect: 'fade',
      closeEffect: 'fade'
    });
  };

  return {
    initialize: initialize
  };
}();